/*=========================================================================================
  管理者用法人船チャンネルAPI
==========================================================================================*/

import http from '@/http/aisea/axios'
const resource = "/secure_dataflow/enterprise/vessels";

export default {
  getChannelVersions(vesselId, params){
    return http.get(`${resource}/${vesselId}/channel_versions/`, {
      params: params
    }).then(response => {
      if(!response.status) {
        return Promise.reject(response)
      } else {
        return response
      }
    })
  },
  getChannels(vesselId, params) {
    return http.get(`${resource}/${vesselId}/channels/`, {
      params: params
    })
  },

  async searchChannelsData(vesselId, body) {
    return http.post(`${resource}/${vesselId}/channel_data/search/`, body )
    .then(response => {
      if(!response.status) {
        return Promise.reject(response)
      } else {
        return response
      }
    })
  },

  searchChannelsDataByStatus(vesselId, body) {
      return http.post(`${resource}/${vesselId}/channel_data/search_by_status/`, body)
  },

  downloadCsv(vesselId, body) {
      return http.post(`${resource}/${vesselId}/channel_data/csv_download/`, body)
  },

  download3dCsv(vesselId, body) {
      return http.post(`${resource}/${vesselId}/channel_data/csv_download_fv/`, body)
  },

  downloadCsvByStatus(vesselId, body) {
    return http.post(`${resource}/${vesselId}/channel_data/csv_download_by_status/`, body)
  },

  searchChannels(vesselId, params) {
      return http.get(`${resource}/${vesselId}/channels/search/`, {
          params: params
      })
  },
};
